import { ICompanyContactPackageBuider } from './companyContactPackageBuilder';
import { IPackageBuilderZone } from './packageBuilderZone';

export class IPackageBuilderException {
    label?: string;
    /** UTC time-of-day HH:mm */
    startTime: string;
    /** UTC time-of-day HH:mm */
    endTime: string;
    daysOfWeek?: number[];
    zones: IPackageBuilderZone[];
}

export class IPackageBuider {
    _id                      : string;
    sn                       : number;
    packageName              : string;
    packageType              : string;
    logo                     : string;
    color                    : string;
    noOfMonths               : number;
    noOfWeeks                : number;
    noOfDays                 : number;
    durationType             : string;
    isDelete                 : boolean;
    noOfMembers              : number;
    description              : string;
    packageFee               : number;
    registerationFee         : number;
    companyContactPerson     : ICompanyContactPackageBuider
    packageFeeType           : string;
    packageRegFeeType        : string;
    isGreaterthanNoOfMembers : boolean;
    branch                   : string;
    company                  : string;
    createdBy                : string;
    createdDate              : Date;
    modifiedBy               : string;
    scope                    : string;
    type                     : string;
    initiatedFrom            : string;
    activityBy               : string;
    ageGroupFrom             : number;
    ageGroupTo               : number;
    modifiedDate             : Date;
    zones                    : IPackageBuilderZone[];
    /** True when this package uses time-based zone access (normal mode + exceptions). */
    isTimeBased              : boolean;
    exceptions               : IPackageBuilderException[];
    groupFeePayByOnePerson   : boolean;
    sameHistory              : boolean;
    freezingDays             : number;
}